import React, { useMemo } from 'react';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';

export default function ReferenceForest({ curve, barrierOffset }) {
  const { scene } = useGLTF('/assets/realistic_tree_models_for_games.glb');
  const forest = useMemo(() => {
    const group = new THREE.Group();
    const placements = [];
    const matrix = new THREE.Matrix4();
    const rotation = new THREE.Quaternion();
    const scale = new THREE.Vector3();
    for (let row = 0; row < 2; row++) {
      for (let i = 0; i < 32; i++) {
        const t = (i / 32 + row / 64) % 1;
        const point = curve.getPointAt(t);
        const tangent = curve.getTangentAt(t).normalize();
        const side = new THREE.Vector3(-tangent.z, 0, tangent.x).normalize();
        for (const direction of [-1, 1]) {
          const distance = barrierOffset + 9 + row * 14 + Math.sin(i * 3.71) * 3;
          const position = point.clone().addScaledVector(side, distance * direction);
          const height = .95 + row * .25 + (Math.sin(i * 7.3 + direction) + 1) * .2;
          rotation.setFromAxisAngle(THREE.Object3D.DEFAULT_UP, i * 2.399 + direction);
          scale.setScalar(height);
          placements.push(matrix.compose(position, rotation, scale).clone());
        }
      }
    }
    scene.updateMatrixWorld(true);
    scene.traverse(source => {
      if (!source.isMesh) return;
      const finish = original => {
        const material = original.clone();
        material.roughness = .88;
        material.alphaTest = Math.max(material.alphaTest || 0, .35);
        return material;
      };
      const material = Array.isArray(source.material) ? source.material.map(finish) : finish(source.material);
      const trees = new THREE.InstancedMesh(source.geometry, material, placements.length);
      placements.forEach((placement, index) => trees.setMatrixAt(index, matrix.multiplyMatrices(placement, source.matrixWorld)));
      // Keep the dense scenery out of the per-frame dynamic shadow pass.
      // Car shadows and the existing sun/track lighting remain active.
      trees.castShadow = false;
      trees.receiveShadow = true;
      trees.computeBoundingSphere();
      group.add(trees);
    });
    return group;
  }, [scene, curve, barrierOffset]);
  return <primitive object={forest} />;
}
